import { render, staticRenderFns } from "./myBaseInputTag.vue?vue&type=template&id=67dfbb49&"
import script from "./myBaseInputTag.vue?vue&type=script&lang=js&"
export * from "./myBaseInputTag.vue?vue&type=script&lang=js&"
import style0 from "./myBaseInputTag.vue?vue&type=style&index=0&id=67dfbb49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports